const GeneralQuestionnaireInfoEditor = function ($scope, questionnaireInteractor) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.title = $ctrl.questionnaire.title;
    $ctrl.description = $ctrl.questionnaire.description;
    $ctrl.shortDescription = $ctrl.questionnaire.short_description;
    if ($ctrl.shortDescription) {
      $ctrl.shortDescCharCount = $ctrl.shortDescription.length;
    }
  };

  $ctrl.editTitle = function () {
    $ctrl.editingTitle = true;
  };

  $ctrl.saveTitle = function () {
    questionnaireInteractor.updateTitle(
      $ctrl.questionnaire.id,
      $ctrl.title,
      function () {
        $ctrl.editingTitle = false;
        $scope.$digest();
      },
      function () {
        alert('Your changes failed to save');
      }
    );
  };

  $ctrl.cancelEditTitle = function () {
    $ctrl.title = $ctrl.questionnaire.title;
    $ctrl.editingTitle = false;
  };

  $ctrl.saveDescription = function (content) {
    return new Promise((resolve) => {
      questionnaireInteractor.updateDescription(
        $ctrl.questionnaire.id,
        content,
        () => {
          $scope.$digest();
          resolve();
        },
        () => {
          console.log("server error");
          throw('Your changes failed to save');
        }
      )
    });
  };

  $ctrl.editShortDescription = function () {
    $ctrl.editingShortDescription = true;
  };

  $ctrl.cancelEditShortDescription = function () {
    $ctrl.shortDescription = $ctrl.questionnaire.short_description;
    $ctrl.shortDescCharCount = $ctrl.shortDescription.length;
    $ctrl.editingShortDescription = false;
  };

  $ctrl.limitShortDescLength = function () {
    if ($ctrl.shortDescription.length > 200) {
      $ctrl.shortDescription = $ctrl.shortDescription.substr(0, 200);
    }

    $ctrl.shortDescCharCount = $ctrl.shortDescription.length;
  };
};

export default {
  name: 'generalQuestionnaireInfoEditor',
  obj: {
    controller: GeneralQuestionnaireInfoEditor,
    templateUrl: 'components/general_questionnaire_info_editor.html',
    bindings: {
      questionnaire: '<'
    }
  }
};